module.exports = __webpack_public_path__ + "img/饥饿.dfd9536a.gif";